<template>
  <div class="contact-page">
    <!-- Hero Section -->
    <section class="hero">
      <div class="container">
        <h1 class="hero-title">Contact Us</h1>
        <p class="hero-subtitle">
          Get in touch with our team to learn more about eClub or get support for your institution
        </p>
      </div>
    </section>

    <!-- Contact Content -->
    <section class="contact-content">
      <div class="container">
        <div class="contact-grid">
          
          <!-- Contact Form -->
          <div class="contact-form-section">
            <h2>Send us a Message</h2>
            <form class="contact-form" @submit.prevent="submitForm">
              <div class="form-group">
                <label for="name">Full Name *</label>
                <input 
                  type="text" 
                  id="name" 
                  v-model="form.name" 
                  required 
                  placeholder="Enter your full name"
                >
              </div>
              
              <div class="form-group">
                <label for="email">Email Address *</label>
                <input 
                  type="email" 
                  id="email" 
                  v-model="form.email" 
                  required 
                  placeholder="Enter your email address"
                >
              </div>
              
              <div class="form-group">
                <label for="institution">Institution Name</label>
                <input 
                  type="text" 
                  id="institution" 
                  v-model="form.institution" 
                  placeholder="Enter your school/institution name"
                >
              </div>
              
              <div class="form-group">
                <label for="role">Your Role</label>
                <select id="role" v-model="form.role">
                  <option value="">Select your role</option>
                  <option value="student">Student</option>
                  <option value="teacher">Teacher/Advisor</option>
                  <option value="admin">School Administrator</option>
                  <option value="parent">Parent</option>
                  <option value="other">Other</option>
                </select>
              </div>
              
              <div class="form-group">
                <label for="subject">Subject *</label>
                <select id="subject" v-model="form.subject" required>
                  <option value="">Select a subject</option>
                  <option value="general">General Inquiry</option>
                  <option value="demo">Request Demo</option>
                  <option value="support">Technical Support</option>
                  <option value="pricing">Pricing Information</option>
                  <option value="partnership">Partnership Opportunity</option>
                  <option value="feedback">Feedback</option>
                </select>
              </div>
              
              <div class="form-group">
                <label for="message">Message *</label>
                <textarea 
                  id="message" 
                  v-model="form.message" 
                  required 
                  rows="5" 
                  placeholder="Please describe your inquiry or question in detail"
                ></textarea>
              </div>
              
              <button type="submit" class="btn btn-primary" :disabled="submitting">
                {{ submitting ? 'Sending...' : 'Send Message' }}
              </button>
            </form>
            
            <div v-if="submitted" class="success-message">
              <h3>✓ Message Sent Successfully!</h3>
              <p>Thank you for contacting us. We'll get back to you within 24 hours.</p>
            </div>
          </div>
          
          <!-- Contact Information -->
          <div class="contact-info-section">
            <h2>Get in Touch</h2>
            
            <div class="contact-methods">
              <div class="contact-method">
                <div class="method-icon">📧</div>
                <div class="method-content">
                  <h3>Email Support</h3>
                  <p>support@eclub.world</p>
                  <span>Response within 5 business days</span>
                </div>
              </div>
              
              
            </div>
            
            <div class="support-hours">
              <h3>Support Hours</h3>
              <ul>
                <li>Monday - Friday: 9:00 AM - 5:00 PM UTC+8</li>
                
              </ul>
            </div>
            
            <!-- <div class="quick-links">
              <h3>Quick Resources</h3>
              <ul>
                <li><a href="#" class="link">Documentation & Guides</a></li>
                <li><a href="#" class="link">Frequently Asked Questions</a></li>
                <li><a href="#" class="link">Video Tutorials</a></li>
                <li><a href="#" class="link">System Status</a></li>
              </ul>
            </div> -->
          </div>
          
        </div>
      </div>
    </section>

    <!-- FAQ Section -->
    <section class="faq">
      <div class="container">
        <h2 class="section-title">Frequently Asked Questions</h2>
        <div class="faq-grid">
          
          <div class="faq-item">
            <h3>How do I get started with eClub?</h3>
            <p>
              Getting started is easy! Contact our team to schedule a demo, and we'll help you 
              set up your institution's account. We provide full onboarding support and training.
            </p>
          </div>
          
          <div class="faq-item">
            <h3>Is eClub suitable for small schools?</h3>
            <p>
              Absolutely! eClub is designed to scale with institutions of all sizes, from small 
              schools with a few clubs to large universities with hundreds of activities.
            </p>
          </div>
          
          <!-- <div class="faq-item">
            <h3>What kind of support do you provide?</h3>
            <p>
              We offer comprehensive support including email, live chat, phone support, 
              documentation, video tutorials, and personalized training sessions.
            </p>
          </div> -->
          
          <!-- <div class="faq-item">
            <h3>Can students access eClub on mobile devices?</h3>
            <p>
              Yes! eClub is fully responsive and works seamlessly on all devices including 
              smartphones, tablets, and desktop computers.
            </p>
          </div> -->
          
          <div class="faq-item">
            <h3>How secure is student data on eClub?</h3>
            <p>
              We take data security very seriously. eClub uses enterprise-grade security 
              measures, encryption, and complies with educational data privacy regulations.
            </p>
          </div>
          
          <!-- <div class="faq-item">
            <h3>Do you offer training for staff?</h3>
            <p>
              Yes! We provide comprehensive training for all user types including students, 
              advisors, and administrators to ensure successful platform adoption.
            </p>
          </div> -->
          
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="cta">
      <div class="container">
        <div class="cta-content">
          <h2>Ready to Get Started?</h2>
          <p>Join hundreds of institutions already transforming their club management with eClub.</p>
          <router-link to="/login" class="btn btn-primary">Start Your Journey</router-link>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'OfficialContact',
  data() {
    return {
      form: {
        name: '',
        email: '',
        institution: '',
        role: '',
        subject: '',
        message: ''
      },
      submitting: false,
      submitted: false
    }
  },
  methods: {
    submitForm() {
      this.submitting = true;
      
      // Simulate form submission
      setTimeout(() => {
        this.submitting = false;
        this.submitted = true;
        this.form = {
          name: '',
          email: '',
          institution: '',
          role: '',
          subject: '',
          message: ''
        };
        
        // Hide success message after 5 seconds
        setTimeout(() => {
          this.submitted = false;
        }, 5000);
      }, 1000);
    }
  }
}
</script>

<style scoped lang="scss">
.contact-page {
  .hero {
    background: linear-gradient(135deg, #fff5f3 0%, #ffe6e3 100%);
    padding: 80px 0 60px;
    text-align: center;
    
    .hero-title {
      font-size: 3rem;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 20px;
    }
    
    .hero-subtitle {
      font-size: 1.3rem;
      color: #666;
      max-width: 600px;
      margin: 0 auto;
    }
  }
  
  .contact-content {
    padding: 80px 0;
    background: white;
    
    .contact-grid {
      display: grid;
      grid-template-columns: 2fr 1fr;
      gap: 80px;
    }
  }
  
  .contact-form-section {
    h2 {
      color: #1a1a1a;
      font-size: 2rem;
      margin-bottom: 30px;
      font-weight: 600;
    }
    
    .contact-form {
      .form-group {
        margin-bottom: 25px;
        
        label {
          display: block;
          color: #333;
          font-weight: 500;
          margin-bottom: 8px;
          font-size: 1rem;
        }
        
        input, select, textarea {
          width: 100%;
          padding: 15px;
          border: 2px solid #e9ecef;
          border-radius: 8px;
          font-size: 1rem;
          transition: border-color 0.3s ease;
          
          &:focus {
            outline: none;
            border-color: #FF6B4A;
          }
          
          &::placeholder {
            color: #999;
          }
        }
        
        textarea {
          resize: vertical;
          min-height: 120px;
        }
      }
    }
    
    .success-message {
      background: #d4edda;
      border: 1px solid #c3e6cb;
      border-radius: 8px;
      padding: 20px;
      margin-top: 20px;
      
      h3 {
        color: #155724;
        margin-bottom: 10px;
        font-size: 1.2rem;
      }
      
      p {
        color: #155724;
        margin: 0;
      }
    }
  }
  
  .contact-info-section {
    h2 {
      color: #1a1a1a;
      font-size: 2rem;
      margin-bottom: 30px;
      font-weight: 600;
    }
    
    .contact-methods {
      margin-bottom: 40px;
    }
    
    .contact-method {
      display: flex;
      align-items: flex-start;
      margin-bottom: 30px;
      
      .method-icon {
        font-size: 2rem;
        margin-right: 15px;
        margin-top: 5px;
      }
      
      .method-content {
        h3 {
          color: #FF6B4A;
          font-size: 1.2rem;
          margin-bottom: 5px;
          font-weight: 600;
        }
        
        p {
          color: #333;
          font-weight: 500;
          margin-bottom: 3px;
        }
        
        span {
          color: #666;
          font-size: 0.9rem;
        }
      }
    }
    
    .support-hours, .quick-links {
      background: #f8f9fa;
      padding: 25px;
      border-radius: 12px;
      margin-bottom: 30px;
      
      h3 {
        color: #1a1a1a;
        font-size: 1.3rem;
        margin-bottom: 15px;
        font-weight: 600;
      }
      
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        
        li {
          color: #666;
          margin-bottom: 8px;
          
          .link {
            color: #FF6B4A;
            text-decoration: none;
            
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
  
  .faq {
    padding: 80px 0;
    background: #f8f9fa;

    .section-title {
      text-align: center !important;
      width: 100%;
      display: block;
      margin: 0 auto 20px;
    }
    
    .faq-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
      gap: 30px;
      margin-top: 50px;
    }
    
    .faq-item {
      background: white;
      padding: 30px;
      border-radius: 12px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
      
      h3 {
        color: #1a1a1a;
        font-size: 1.2rem;
        margin-bottom: 15px;
        font-weight: 600;
      }
      
      p {
        color: #666;
        line-height: 1.6;
        margin: 0;
      }
    }
  }
  
  .cta {
    background: linear-gradient(135deg, #FF6B4A 0%, #ff8a6b 100%);
    padding: 80px 0;
    text-align: center;
    
    .cta-content {
      max-width: 600px;
      margin: 0 auto;
      
      h2 {
        color: white;
        font-size: 2.5rem;
        margin-bottom: 20px;
        font-weight: 600;
      }
      
      p {
        color: rgba(255, 255, 255, 0.9);
        font-size: 1.2rem;
        margin-bottom: 30px;
      }
    }
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 20px;
}

.btn {
  display: inline-block;
  padding: 18px 35px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  
  &.btn-primary {
    background: #FF6B4A;
    color: white;
    
    &:hover:not(:disabled) {
      background: #e55a41;
      transform: translateY(-2px);
    }
    
    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
}

// Special styling for CTA button in cta section
.cta .btn.btn-primary {
  background: white;
  color: #FF6B4A;
  
  &:hover {
    background: #f8f9fa;
    color: #FF6B4A;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 2.2rem;
  }
  
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 60px;
  }
  
  .faq-grid {
    grid-template-columns: 1fr;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .contact-method {
    align-items: center;
    text-align: center;
    flex-direction: column;
    
    .method-icon {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
}
</style>